import React, { useState, useEffect } from "react";
import "./portfolio.css";
import data from "./data";

const Portfolio = () => {
  const [projects, setProjects] = useState(data);
  const [pagesAmmount, setPagesAmmount] = useState(1);
  const [pagesArray, setPagesArray] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const newArr = [];

    for (let i = 1; i <= pagesAmmount; i++) {
      newArr.push(i);
    }

    setPagesArray(newArr);
    setPagesAmmount(Math.ceil(data.length / 6));
    setProjects(data.slice((currentPage - 1) * 6, currentPage * 6));
  }, [pagesAmmount, projects, pagesArray, currentPage]);

  return (
    <section id="portfolio">
      <h5>My Projects</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {projects.map((project) => (
          <article className="portfolio__item" key={project.id}>
            <div className="portfolio__item-image">
              <img rel="preload" src={project.image} alt={project.title} />
            </div>
            <h3>{project.title}</h3>
            <div className="btn__container">
              <a
                href={project.githubLink}
                className="btn"
                target="_blank"
                rel="noreferrer"
              >
                Github
              </a>
              <a
                href={project.demo}
                className="btn btn-primary"
                target="_blank"
                rel="noreferrer"
              >
                Demo
              </a>
            </div>
          </article>
        ))}
      </div>
      <ul className="portfolio__pages">
        {pagesArray.map((pageNumber) => (
          <li
            className={`portfolio__page${
              pageNumber === currentPage ? " active-page" : ""
            }`}
            key={pageNumber}
            onClick={() => setCurrentPage(pageNumber)}
          >
            {pageNumber}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Portfolio;
